import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import PropTypes from "prop-types";

const DEGREE_ORDER = ["low", "moderate", "high", "severe", "critical"];

const degreeNumberMap = {
  1: "low",
  2: "moderate",
  3: "high",
  4: "severe",
  5: "critical",
};

const DEGREE_STYLES = {
  low: {
    label: "1: Low",
    bg: "#e8f5e9",
    border: "#66bb6a",
    text: "#2e7d32",
    desc: "Low is the new alert we just received through the system with priority 1.",
  },
  moderate: {
    label: "2: Moderate",
    bg: "#fffde7",
    border: "#fdd835",
    text: "#f9a825",
    desc: "Moderate alerts indicate a slightly more urgent condition - priority 2.",
  },
  high: {
    label: "3: High",
    bg: "#fff3e0",
    border: "#fb8c00",
    text: "#ef6c00",
    desc: "High alerts require timely attention with priority 3 severity.",
  },
  severe: {
    label: "4: Severe",
    bg: "#fce4ec",
    border: "#f48fb1",
    text: "#c2185b",
    desc: "Severe alerts represent serious conditions, marked as priority 4.",
  },
  critical: {
    label: "5: Critical",
    bg: "#ffdde0",
    border: "#d32f2f",
    text: "#a30000",
    desc: "Critical alerts demand immediate response - priority 5.",
  },
};

const PriorityDegreeBar = ({ degree, ...props }) => {
  let normalized = null;

  if (typeof degree === "number") {
    normalized = degreeNumberMap[degree];
  } else if (typeof degree === "string") {
    normalized = degree.toLowerCase();
  }

  const activeIndex = normalized
    ? DEGREE_ORDER.indexOf(normalized)
    : DEGREE_ORDER.length - 1;

  return (
    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 3, ...props.sx }}>
      {DEGREE_ORDER.map((key, index) => {
        const isActive = normalized === null || index <= activeIndex;
        const { label, bg, border, text, desc } = DEGREE_STYLES[key];

        return (
          <Paper
            key={key}
            elevation={isActive ? 3 : 1}
            sx={{
              flex: "1 1 220px",
              minWidth: "180px",
              borderLeft: `6px solid ${isActive ? border : "#ccc"}`,
              borderRadius: 1,
              backgroundColor: isActive ? bg : "#f4f4f4",
              transition: "all 0.3s ease",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
              px: 2,
              py: 1.5,
            }}
          >
            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{ color: isActive ? text : "#888", mb: 1 }}
            >
              {label}
            </Typography>

            <Typography
              variant="caption"
              sx={{ color: isActive ? "#444" : "#aaa", fontSize: "0.75rem" }}
            >
              {desc}
            </Typography>
          </Paper>
        );
      })}
    </Box>
  );
};

export default PriorityDegreeBar;
export { DEGREE_STYLES, degreeNumberMap };

PriorityDegreeBar.propTypes = {
  degree: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sx: PropTypes.object,
};
